export function deepCopy(data){
    let copyData = JSON.parse(JSON.stringify(data));
    return copyData;
}

export function generateUniqueId() {
    return Date.now() + Math.floor(Math.random() * 1000); // 时间戳加上一个随机数
}

// 方法：根据传入的id删除对应对象
export function deleteProductById(id,cartItem) {
    let products = deepCopy(cartItem)
    // 查找数组中该对象的索引
    const index = products.findIndex(product => product.id === id);
    // 如果找到对象，则删除
    if (index !== -1) {
      products.splice(index, 1); // 删除该索引位置的对象
      console.log(`已删除ID为 ${id} 的对象`);
    } else {
      console.log(`未找到ID为 ${id} 的对象`);
    }
    return products;
}

export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent);
  // return userAgent;
  return /android|iphone|ipad|ipod|mobile|windows phone/.test(userAgent);
}


// WEBPACK FOOTER //
// ./src/utils/index.js